export const getSsoConfig = () => ({
  type: 'AUTH_GET_SSO_CONFIG'
});

export const getSsoConfigFailed = () => ({
  type: 'AUTH_GET_SSO_CONFIG_FAILED'
});

export const setSsoConfig = (config) => ({
  type: 'AUTH_SET_SSO_CONFIG',
  data: config
});

export const setSsoPageNavigated = (dispatch) => (navigatedToSsoPage) =>
  dispatch({
    type: 'AUTH_SET_SSO_PAGE_NAVIGATED',
    navigatedToSsoPage
  });
